module.exports = __webpack_public_path__ + "static/media/003.8f1b74de.jpg";